export default __webpack_public_path__ + "static/media/arrowCircleLeft.6fb66b11.svg";